import React from 'react';
import FileComponent from './File';
import { emptyArray } from '../../constants/collections';
import styles from './index.module.scss';

const Files = ({
  data = emptyArray,
  commentId,
  layout = 'horizontal',
  removeFile,
}) => {
  return (
    <div className={styles.root} data-layout={layout}>
      {data.map((file, index) => {
        return (
          <FileComponent
            key={index}
            index={index}
            file={file}
            commentId={commentId}
            removeFile={removeFile}
          />
        );
      })}
    </div>
  );
};

export default Files;
